module.exports = __webpack_public_path__ + "img/classic_4.65438c21.png";